
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    async performRecommendations() {
      const url = this.dataset.url;
      if (!url) return;

      const isComplementary = new URL(url, window.location.origin)
        .searchParams.get('intent') === 'complementary';

      const recommendationsContainer = this.querySelector('[data-recommendations]');

      // Pozostałe sekcje korzystają z data-recommendations.
      if (!isComplementary && !recommendationsContainer) return;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const doc = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

        if (isComplementary) {
          // Pobieramy produkty uzupełniające z Shopify.
          const source = Array.from(
            doc.querySelectorAll('product-recommendations')
          ).find(element => {
            const sourceUrl = element.getAttribute('data-url');

            return sourceUrl && new URL(sourceUrl, window.location.origin)
              .searchParams.get('intent') === 'complementary';
          });

          if (!source || !source.querySelector('.product__complementaries-item')) {
            this.classList.add('hidden');
            return;
          }

          this.innerHTML = source.innerHTML;

        } else {
          // Zachowujemy działanie pozostałych rekomendacji.
          const source = doc.querySelector('[data-recommendations]');

          if (!source || !source.innerHTML.trim()) return;

          recommendationsContainer.innerHTML = source.innerHTML;
        }

        this.classList.remove('hidden');
        this.initSlider();

        const quickCart = document.querySelector('quick-cart-drawer');

        if (quickCart && typeof quickCart.init === 'function') {
          setTimeout(() => quickCart.init(), 500);
        } else if (!quickCart) {
          this.querySelectorAll('.quick-cart-drawer__trigger')
            .forEach(el => el.remove());
        }

      } catch (error) {
        console.error('Product recommendations error:', error);
      }
    }

    initSlider() {
      const swiper = this.querySelector('.swiper');

      if (!swiper || typeof Swiper === 'undefined') return;

      if (this.slider) {
        this.slider.destroy(true, true);
      }

      this.slider = new Swiper(swiper, {
        slidesPerView: 'auto',
        spaceBetween: 16
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
